<template>
    
    <article class="reservation" v-if="data">

        <header>
            <h3>
                {{ data.title }}
            </h3>
            <p v-if="data.status === 0" class="status pending">Afventer godkendelse</p>
            <p v-if="data.status === 1" class="status approved">Godkendt</p>
            <p v-if="data.status === 2" class="status rejected">Afvist</p>
            <p v-if="data.status === 3" class="status cancelled">Slettet</p>
        </header>
        <p v-if="data.status !== 0 && data.status_reason" class="reason">
            <span v-if="data.status === 1">Godkendt</span>
            <span v-if="data.status === 2">Afvist</span>
            <span v-if="data.status === 3">Slettet</span>
            <span> med begrundelsen: </span> 
            {{ data.status_reason }}
        </p>
        <dl>
            <dt>Reservation af</dt>
            <dd>{{ data.resource_name }}, {{ data.resource_admin_unit.name }}</dd>
            <dt>Periode</dt>
            <dd v-html="period"></dd>
            <dt>Reserveret af</dt>
            <dd v-if="data.creator_details">
                {{ data.creator_details.first_name }} {{ data.creator_details.last_name }}
                ({{ data.creator_details.email }})<br>
                <template v-if="data.creator_details.guest">
                    {{ data.creator_details.guest.address.street }}
                    {{ data.creator_details.guest.address.number }}
                    {{ data.creator_details.guest.address.floor }}
                    {{ data.creator_details.guest.address.door }}
                    <br>
                    {{ data.creator_details.guest.address.zipcode }}
                    {{ data.creator_details.guest.address.town }}
                    <br>
                    &#128222; {{ data.creator_details.guest.phone }}
                </template>
            </dd>
            <template v-if="locks">
                <dt>Dørlåskode</dt>
                <dd>
                    <p v-for="l in locks" style="margin: 0;">
                        {{ l.code }}
                        <span class="emphasize">*</span>
                    </p>
                    <p class="muted">
                        Tast cifrene efterfulgt af stjerne (*)
                    </p>
                </dd>
            </template>
            <template v-if="data.description">
                <dt>Formål</dt>
                <dd>{{ data.description }}</dd>
            </template>
        </dl>
        <p class="actions">
            <router-link v-if="user.is_staff" :to="`/bookinglist/${ data.id }/edit`">Redigér</router-link>
            <router-link v-else :to="`/booking/${ data.id }/edit`">Redigér</router-link>
        </p>
    
    </article>

</template>

<script>

    import { dateDjango2js, displayJSDate, displayJSTime } from '../../utils/Filters.js'
    import axios from '../../utils/Http.js'

    export default {
        props: [
            'data'
        ],
        data: function() {
            return {
                locks: false
            }
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            },
            period: function() {
                let start = dateDjango2js(this.data.start),
                    end = dateDjango2js(this.data.end),
                    sameday = true
                if (displayJSDate(start) === displayJSDate(end)) {
                    return `${ displayJSDate(start) }, ${ displayJSTime(start) } - ${ displayJSTime(end) }`
                } else {
                    return `fra ${ displayJSDate(start) } ${ displayJSTime(start) } <br>til ${ displayJSDate(end) } ${ displayJSTime(end) }`
                }
            }
        },
        watch: {
            data: function() {
                this.update()
            }
        },
        methods: {
            update: function() {
                if (this.data) {
                    this.fetchLockInfo(this.data.id)
                }
            },
            fetchLockInfo: function(booking_id) {
                axios({
                    method: 'get',
                    url: `/locks/code?booking__id=${ booking_id }`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    if (res.data.length > 0) {
                        this.locks = res.data
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        created: function() {
            this.update()
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    .reservation {
        padding: 1rem;

        header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;

            h1 {
                margin: 0;
                font-size: 1.25rem;
            }
        }
        .status {
            padding: .25rem .5rem;
            font-size: smaller;
            margin: 0 0 0 1rem;
            
            &.pending {
                background-color: $warning;
                color: darken($warning, 50%);
            }
            &.approved {
                background-color: $success;
                color: darken($success, 50%);
            }
            &.rejected {
                background-color: $danger;
                color: darken($danger, 50%);
            }
            &.cancelled {
                background-color: $grey8;
                color: $grey2;
            }
        }
        .reason {
            border: solid 1px $grey1;
            padding: .5rem 1rem;
            margin: .5rem 0;

            span {
                opacity: .5;
            }
        }
        .emphasize {
            font-size: 1.5rem;
            line-height: 1;
            position: relative;
            top: .25em;
        }
    }

</style>
